<template>
  <div class="new-exam-uploads-container">
    <v-data-table 
      v-show="files.length"
      :headers="headers"
      :items="files"
      hide-default-footer
      disable-sort>
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{props.item.name}}</td>
          <td>
            <span :class="uploadStateClass(props.item.state)">{{props.item.state}}</span>
          </td>
          <td>{{formatBytes(props.item.size)}}</td>
          <td>
            <span>Eye Type: </span>
            <v-select
              class="eyeDropdown"
              :items="eyeTypes" 
              v-model="props.item.eye"/>
            <v-checkbox
              class="checkbox"
              :color="colorHex"
              v-model="props.item.batchEyeSelected"></v-checkbox>
          </td>
          <td>
            <v-hover>
              <v-btn
                icon
                @click="$emit('deleteFile', props.item)"
                slot-scope="{ hover }"
                :disabled="disabled">
                <img v-if="hover" src="../../assets/Delete_Blue.png" class="patientDetailTableIcon" />
                <img v-else src="../../assets/Delete - White.png" class="patientDetailTableIcon" />
              </v-btn>
            </v-hover>
          </td>
        </tr>                        
      </template>
    </v-data-table>
    <span>Change Selected Eye Types To: </span>
    <v-select
      class="eyeDropdown"
      :items="batchEyeTypes" 
      item-color="white"
      v-model="batchEyeType"
      @input="batchEdit"/>
  </div>
</template>

<script>
import { formatBytes } from "../../helpers/utils";
import uploadExamFiles from "../mixins/UploadExamFiles";

export default {
  name: "patientFileUploadTable",
  props: {
    files: Array,
    disabled: Boolean
  },
  mixins: [
    uploadExamFiles
  ],
  data() {
    return {
      headers: [
        {text: "File Name", value:"File Name"}, 
        {text: "Status", value:"Status"}, 
        {text: "Size", value:"Size"}, 
        {text: "Eye Type", value:"Eye Type"}, 
        {text: "", value:"Delete"}],
      selected: [],
      eyeTypes: ["OD", "OS", "OU", "U"],
      batchEyeTypes: ["OD", "OS", "OU"],
      batchEyeType: ""
    };
  },
  methods: {
    uploadStateClass(state) {
      return state === "Completed" ? "upload-state-completed" 
        : state === "Error" ? "upload-state-error" : "";
    },
    batchEdit() {
      this.batchEditEyeType(this.files, this.batchEyeType);
    },
    formatBytes: formatBytes
  }
};
</script>

<style lang="scss" scoped >
.upload-state-completed {
  color: $color-blue;
}
.upload-state-error {
  color: $color-red;
}
</style>
